// @ts-strict-ignore
/** @jsx jsx */
import React from 'react'
import { jsx } from 'theme-ui'
import SimpleTable from './simple-table'
import PlatinumTable from './platinum-table'
import Chart from './chart'

export const getDateString = (localDates?: Date, globalDates?: Date): string | null => {
  const publishDateString = localDates?.dateCreated || globalDates?.dateCreated
  const updatedDateString = localDates?.dateUpdated || globalDates?.dateUpdated

  const publishDate = publishDateString ? new Date(publishDateString) : null
  const updatedDate = updatedDateString ? new Date(updatedDateString) : null

  if (!publishDate && !updatedDate) {
    return null
  }

  const prefix = updatedDate ? 'Updated' : 'Published'
  const dateObj = updatedDate || publishDate

  const dateArr = [
    dateObj.getDate(),
    dateObj.toLocaleString('default', { month: 'long' }),
    dateObj.getFullYear(),
  ]

  return `${prefix} ${dateArr.join(' ')}`
}

export function handleMarks(value, marks) {
  return (
    <span style={markStyles(marks)}>
      {marks?.link ? (
        <a href={marks.link} target='_blank' rel='noreferrer'>
          {value}
        </a>
      ) : (
        value
      )}
    </span>
  )
}

function markStyles(marks = {}) {
  return {
    fontWeight: marks.b ? '700' : 'initial',
    fontStyle: marks.i ? 'italic' : 'initial',
    textDecoration: marks.u ? 'underline' : 'initial',
  }
}

const Table = (props) => {
  if (props.tableVariant === 'platinum') {
    return <PlatinumTable {...props} />
  } else if (props.tableVariant === 'platinum-chart') {
    return <Chart {...props} />
  } else {
    return <SimpleTable {...props} />
  }
}

export default Table
